import { createReducer } from '../../utils';
import types from './types';

export const initialState = {
    data: null,
    impression: []
};

const ACTION_HANDLERS = {
    [types.SAVE_TRACKING_DATA]: (state, action) => ({
        ...state,
        data: {
            ...action.payload,
            ...{ type: '' } // TODO Take a closer look whats happening here
        }
    }),

    [types.SAVE_IMPRESSION_DATA]: (state, action) => ({
        ...state,
        impression: [...state.impression, action.payload]
    }),

    [types.CLEAR_IMPRESSION_DATA]: state => ({
        ...state,
        impression: initialState.impression
    })
};

export default createReducer(ACTION_HANDLERS, initialState);
